// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body {\n\tbackground: #ebebeb;\n\t/*min-height: 100%;*/\n\theight: auto;\n\toverflow: all;\n\tflex: 1 1 auto;\n\t/*z-index: 1;*/\n}\n\n.body-container {\n\tmax-width: 1200px;\n\twidth: auto;\n\tmargin: auto;\n\tbackground-color: white;\n\tmin-height: 100%;\n\theight: auto;\n\t/*z-index: 2;*/\n\t/*box-shadow: 0px 5px 5px #83A4CE;*/\n}", ""]);
// Exports
module.exports = exports;
